import React from 'react';
import { useLang, availableLanguages, Lang } from '../i18n';

const LanguageDropdownCompact: React.FC = () => {
  const { lang, setLang } = useLang();

  return (
    <select 
      value={lang} 
      onChange={(e) => setLang(e.target.value as Lang)}
      style={{
        padding: '4px 8px',
        fontSize: '0.85rem',
        border: '1px solid #c7d6e7',
        borderRadius: '6px',
        background: '#fff',
        cursor: 'pointer',
        outline: 'none',
        color: '#555'
      }}
    >
      {availableLanguages.map((language) => (
        <option key={language.code} value={language.code}>
          {language.flag}
        </option>
      ))}
    </select>
  );
};

export default LanguageDropdownCompact;
